module.exports = __webpack_public_path__ + "static/layer5-b7f920a60ba0c46773e800aa9fa88afc.png";